import { render, staticRenderFns } from "./InfoLeads.vue?vue&type=template&id=7b2c42d4&"
import script from "./InfoLeads.vue?vue&type=script&lang=js&"
export * from "./InfoLeads.vue?vue&type=script&lang=js&"
import style0 from "./InfoLeads.vue?vue&type=style&index=0&id=7b2c42d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports